/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'backgrounds/bubble': {
    width: 404,
    height: 133,
    viewBox: '0 0 404 133',
    data: '<rect pid="0" width="404" height="133" rx="66.5" _fill="#fff"/>'
  }
})
